import { OrderData } from "../components/OrderCard";

export const MOCK_PERSONAS = {
  SARAH_NEW: {
    id: "sarah",
    name: "Sarah (New User)",
    description: "Just bought a Family Tree, hasn't started yet.",
    orders: [
      {
        paypalOrderId: "ORD-SARAH-1",
        userId: "sarah",
        status: "awaiting-info",
        amount: 145.00,
        currency: "USD",
        createdAt: new Date().toISOString(),
        items: [{
          productId: "pft-5-gen",
          name: "5 Generation Photo Family Tree",
          price: 145.00,
          quantity: 1,
          selectedOptions: { generations: "5", size: "24x36" },
          description: "Custom Family Tree",
          image: "/images/shop/trees/5-gen.jpg",
          requiredForms: ["FamilyTree", "Photos"]
        }],
        actionsRequired: ["FamilyTree", "Photos"],
        formStatus: {},
        formData: {},
        shippingAddress: {
          name: "Sarah Jones",
          city: "Salt Lake City",
          state: "UT",
          country: "US",
          address1: "123 Main St",
          zip: "84101"
        }
      }
    ] as OrderData[]
  },
  LINDA_MISSION: {
    id: "linda",
    name: "Linda (Mission Mom)",
    description: "Has multiple missionary orders in different states.",
    orders: [
      {
        paypalOrderId: "ORD-LINDA-1",
        userId: "linda",
        status: "pending",
        amount: 85.00,
        currency: "USD",
        createdAt: new Date(Date.now() - 86400000).toISOString(), // Yesterday
        items: [{
          productId: "mpa-standard",
          name: "Missionary Photo Art - Standard",
          price: 85.00,
          quantity: 1,
          selectedOptions: { size: "11x14" },
          description: "Missionary Art",
          image: "/images/shop/missionary/standard.jpg",
          requiredForms: ["Missionary"]
        }],
        actionsRequired: ["Missionary"],
        formStatus: {},
        formData: {},
        shippingAddress: {
            name: "Linda Smith",
            city: "Provo",
            state: "UT",
            country: "US",
            address1: "456 Temple View Dr",
            zip: "84604"
        }
      },
      {
        paypalOrderId: "ORD-LINDA-2",
        userId: "linda",
        status: "in-progress",
        amount: 85.00,
        currency: "USD",
        createdAt: new Date(Date.now() - 604800000).toISOString(), // 1 week ago
        items: [{
          productId: "mpa-standard",
          name: "Missionary Photo Art - Sister",
          price: 85.00,
          quantity: 1,
          selectedOptions: { size: "11x14" },
          description: "Missionary Art",
          image: "/images/shop/missionary/standard.jpg",
          requiredForms: ["Missionary"]
        }],
        actionsRequired: [],
        formStatus: { Missionary: true },
        formData: { Missionary: { missionaryName: "Sister Smith" } },
        shippingAddress: {
            name: "Linda Smith",
            city: "Provo",
            state: "UT",
            country: "US",
            address1: "456 Temple View Dr",
            zip: "84604"
        }
      }
    ] as OrderData[]
  },
  MARK_GIFT: {
    id: "mark",
    name: "Mark (Generational Gift)",
    description: "Bought a generational chart for his dad.",
    orders: [
      {
        paypalOrderId: "ORD-MARK-1",
        userId: "mark",
        status: "awaiting-info",
        amount: 120.00,
        currency: "USD",
        createdAt: new Date().toISOString(),
        items: [{
          productId: "ga-4-gen",
          name: "4 Generation Father/Son Chart",
          price: 120.00,
          quantity: 1,
          selectedOptions: { generations: "4" },
          description: "Generational Art",
          image: "/images/shop/generational/4-gen.jpg",
          requiredForms: ["Generational"]
        }],
        actionsRequired: ["Generational"],
        formStatus: {},
        formData: {},
        shippingAddress: {
            name: "Mark Johnson",
            city: "Mesa",
            state: "AZ",
            country: "US",
            address1: "789 Cactus Ln",
            zip: "85201"
        }
      }
    ] as OrderData[]
  },
  COMPLETED_USER: {
    id: "completed",
    name: "Happy Customer (Completed)",
    description: "Order is delivered and ready for download.",
    orders: [
      {
        paypalOrderId: "ORD-DONE-1",
        userId: "completed",
        status: "delivered", // or ready-for-download
        amount: 200.00,
        currency: "USD",
        createdAt: new Date(Date.now() - 2592000000).toISOString(), // 30 days ago
        items: [{
          productId: "pft-7-gen",
          name: "7 Generation Masterpiece",
          price: 200.00,
          quantity: 1,
          selectedOptions: { generations: "7" },
          description: "Big Tree",
          image: "/images/shop/trees/7-gen.jpg",
          requiredForms: []
        }],
        actionsRequired: [],
        formStatus: { FamilyTree: true, Photos: true },
        formData: {},
        shippingAddress: {
            name: "Happy User",
            city: "Rexburg",
            state: "ID",
            country: "US",
            address1: "101 Potato Rd",
            zip: "83440"
        }
      }
    ] as OrderData[]
  }
};
